export default __webpack_public_path__ + "static/media/2.dbe9c82f.svg";